import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";

export const fetchMentorDashboardData = async (token) => {
  try {
    const response = await api.get(API.dashboard.mentorDashboard); 
    return response.data;
  } catch (error) {
    console.error("Error fetching mentor dashboard data:", error);
    throw error;
  }
};
